import { useMemo } from "react";
import { computeEdgeOffsets } from "./edgeLayout";

export default function EdgeLayer({ edges, nodeMap }) {
    const edgeOffsets = useMemo(() => computeEdgeOffsets(edges), [edges]);

    return (
        <svg
            width="30000"
            height="30000"
            style={{
                position: "absolute",
                overflow: "visible",
                pointerEvents: "none",
            }}
        >
            {edges.map((edge) => {
                const from = nodeMap[edge.from];
                const to = nodeMap[edge.to];

                if (!from || !to) return null;

                const offsets = edgeOffsets[edge.id];

                return (
                    <line
                        key={edge.id}
                        x1={from.x + (from.width || 0) + 78}
                        y1={from.y + offsets.fromOffset}
                        x2={to.x - 50}
                        y2={to.y + offsets.toOffset}
                        stroke={edge.color || "#334155"}
                        strokeWidth="2"
                    />
                );
            })}
        </svg>
    );
}
